import React, { useState, useEffect } from "react";
import { Form, Input } from "antd";
import API from "../../library/helpers/api";
import IntlMessages from "@iso/components/utility/intlMessages";
import { renderMessage } from "../../library/helpers/renderInputMessage";
import { useAuth } from "../../contexts/auth";
import { UserOutlined } from "@ant-design/icons";

function PersonalForm({ data }) {
  const { UpdatePartner } = useAuth();

  const [updating, setUpdating] = useState({
    company: null,
    tax_id: null,
  });

  const handleBlur = async (e) => {
    let payload = {};
    let temp = updating;
    const field = e.target.id;
    if (updating[field] === true) {
      temp[field] = "validating";
      setUpdating({ ...updating, ...temp });
      payload[field] = e.target.value;

      await UpdatePartner(payload)
        .then(() => {
          temp[field] = "success";
          setUpdating({ ...updating, ...temp });
        })
        .catch(() => {
          temp[field] = "error";
          setUpdating({ ...updating, ...temp });
        });
    }
  };

  return (
    <Form className="account-forms" layout="vertical">
      <Form.Item
        label={<IntlMessages id="page.myAccount.forms.company.name" />}
        hasFeedback
        validateStatus={updating.company}
        help={renderMessage("company", updating)}
      >
        <Input
          id="company"
          size="large"
          disabled
          defaultValue={data.name}
          onBlur={(e) => handleBlur(e)}
          onInput={(e) => {
            setUpdating({ ...updating, company: true });
          }}
          prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
          placeholder="Company name"
        />
      </Form.Item>

      <Form.Item
        label={<IntlMessages id="page.myAccount.forms.company.taxId" />}
        hasFeedback
        validateStatus={updating.tax_id}
        help={renderMessage("tax_id", updating)}
      >
        <Input
          id="tax_id"
          size="large"
          defaultValue={data.tax_id}
          onBlur={(e) => handleBlur(e)}
          onInput={(e) => {
            setUpdating({ ...updating, tax_id: true });
          }}
          prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
          placeholder="Tax ID"
        />
      </Form.Item>
    </Form>
  );
}
export default PersonalForm;
